import { render, staticRenderFns } from "./work_items_csv_import_modal.vue?vue&type=template&id=7bf08286"
import script from "./work_items_csv_import_modal.vue?vue&type=script&lang=js"
export * from "./work_items_csv_import_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports